import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';

interface CultureSelectProps {
  value: string;
  onCultureChange: (value: string) => void;
  cssClass?: string;
  fullWidth?: boolean;
  labelText?: string;
}

const supportedCultures = [
  { value: 'nl-NL', label: 'Dutch - The Netherlands' },
  { value: 'en-GB', label: 'English - United Kingdom' },
  { value: 'en-NL', label: 'English - The Netherlands' },
  { value: 'en-US', label: 'English - United States' },
  { value: 'fr-FR', label: 'French - France' },
  { value: 'de-DE', label: 'German - Germany' },
  { value: 'pl-PL', label: 'Polish - Poland' },
  { value: 'ru-RU', label: 'Russian - Russia' },
  { value: 'es-ES', label: 'Spanish - Spain' }
];

const CultureSelect = ({ value, onCultureChange, cssClass, fullWidth, labelText }: CultureSelectProps) => {
  const { t } = useTranslation();

  const handleCultureChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const cultureValue = event.target.value as string;
    onCultureChange(cultureValue);
  };

  return (
    <FormControl className={cssClass} variant="outlined" fullWidth={fullWidth} size="small">
      <InputLabel id="cultureLabel">{labelText || t('f-com-culture')}</InputLabel>
      <Select
        label={t('f-com-culture')}
        labelId="cultureLabel"
        id="cultureSelect"
        value={value}
        onChange={handleCultureChange}
      >
        {supportedCultures.map((c) => (
          <MenuItem key={c.value} value={c.value}>
            {c.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CultureSelect;
